"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinearLoader = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = require("../../utils/classify");
var _qa = require("../../utils/qa");
var _LinearLoaderModule = _interopRequireDefault(require("./LinearLoader.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LinearLoader = exports.LinearLoader = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    value,
    size = 'medium',
    className,
    indeterminate,
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'loader'
    }),
    className: (0, _classify.classify)(_LinearLoaderModule.default.lineContainer, {
      [_LinearLoaderModule.default.large]: size === 'large',
      [_LinearLoaderModule.default.medium]: size === 'medium',
      [_LinearLoaderModule.default.small]: size === 'small'
    }, className),
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.classify)(_LinearLoaderModule.default.progressBar, {
        [_LinearLoaderModule.default.indeterminate]: indeterminate
      }),
      style: {
        width: `${value + '%'}`
      },
      role: "progressbar",
      "aria-valuenow": indeterminate ? undefined : value,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    })
  });
});